<script>
	import './index.scss';
	import { pkgBrief, outputFileName, modalIsActive } from "../store.js";
	import { jsPDF } from "jspdf";
	import ImageTools from "../imagetools.js";

	let outputFileNamePdf = $outputFileName + '.pdf';

	let currentPositionX = 20;
	let currentPositionY = 40;
	const breakPosition = 10;

	let doc = new jsPDF({orientation: 'p',
		unit: 'px',
		format: 'a3'
	});

	const maxWidth = doc.internal.pageSize.getWidth() - 50;
	const maxHeight = doc.internal.pageSize.getHeight() - 100;

	function closeModal(){
		$modalIsActive = false;
	};

	function pdfHandler(){
		for(let i=0; i<$pkgBrief.length; i++){
			if($pkgBrief[i].type === 0){
				if ((currentPositionY >= maxHeight) && (i+1 < $pkgBrief.length)) {
					doc.addPage("a3", "p");
					currentPositionY = 40;
				};
				doc.setFontSize(25);
				doc.setFont('times','bold');
				doc.text($pkgBrief[i].content, currentPositionX, currentPositionY);
				currentPositionY = currentPositionY + 25 + breakPosition;
			} else 
			if($pkgBrief[i].type === 1){
				if ((currentPositionY >= maxHeight) && (i+1 < $pkgBrief.length)) {
					doc.addPage("a3", "p");
					currentPositionY = 40;
				};
				doc.setFontSize(17);
				doc.setFont('times','normal');

				let splitText = doc.splitTextToSize($pkgBrief[i].content, maxWidth);
				doc.text(splitText, currentPositionX, currentPositionY);
				console.log(splitText);
				// doc.text($pkgBrief[i].content, currentPositionX, currentPositionY);
				currentPositionY = currentPositionY + (17 * splitText.length) + breakPosition;
			} else
			if($pkgBrief[i].type === 2){
				if (currentPositionY + $pkgBrief[i].height > maxHeight) {
					doc.addPage("a3", "p");
					currentPositionY = 40;
				};
				doc.addImage($pkgBrief[i].detail, "JPEG", currentPositionX, currentPositionY, $pkgBrief[i].width, $pkgBrief[i].height, "a"+i, 'NONE', 0);
				currentPositionY = currentPositionY + $pkgBrief[i].height + breakPosition;
			}
			else {
				if ((currentPositionY >= maxHeight) && (i+1 < $pkgBrief.length)) {
					doc.addPage("a3", "p");
					currentPositionY = 40;
				};
				doc.setFontSize(20);
				doc.setFont('times','normal');
				let date = 'Date: ' + $pkgBrief[i].content;
				doc.text(date, currentPositionX, currentPositionY);
				currentPositionY = currentPositionY + 20 + breakPosition;
			};
		};
		doc.save(outputFileNamePdf);
		$modalIsActive = false;
	};

	let image = [];

	function countSizeOfImage(i) {
		ImageTools.resize($pkgBrief[i].content, {
			width: maxWidth,
			height: maxHeight 
		}, function(blob, didItResize) {
			image[i].src = URL.createObjectURL(blob);
			$pkgBrief[i].detail = URL.createObjectURL(blob);
		});
		$pkgBrief[i].width = image[i].width;
		$pkgBrief[i].height = image[i].height;
	}

</script>

<div class="modal" class:is-active={$modalIsActive}>
	<div class="modal-background" on:click={closeModal}></div>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Preview</p>
			<button class="delete" aria-label="close" on:click={closeModal}></button>
		</header>
		<section class="modal-card-body">
			<div class="content" id="preview-content">
				{#each $pkgBrief as brief, i}
				{#if brief.type == 0}
				<h2>{brief.content}</h2>
				{:else if brief.type == 1}
				<p>{brief.content}</p>
				{:else if brief.type == 2}
				<img src={brief.detail} on:load={() => countSizeOfImage(i)} bind:this={image[i]}/>
				{:else if brief.type == 3}
				<p>Date: {brief.content}</p>
				{/if}
				{/each}
			</div>
		</section>
		<footer class="modal-card-foot buttons is-right">
			<button class="button is-success" on:click={() => pdfHandler()}>Download PDF</button>
			<button class="button" on:click={closeModal}>Cancel</button>
		</footer>
	</div>
</div>